import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchStatusLogFilterEntity } from '../../domain/entities/BranchSTatusLogFilterEntity'

export class BranchStatusLogFilterModel extends BranchStatusLogFilterEntity {
  constructor(dataDto: BranchStatusLogFilterEntity) {
    super()
    mapEntityProperties<BranchStatusLogFilterModel>(this, dataDto)
  }
}
